// App.js
import React from 'react';
import RouteNavigation from './components/Routes/Navigation';
import { ThemeProvider } from "@mui/material";
import { appTheme } from "./theme";
import './App.css'

function App() {
  return (
     <ThemeProvider theme={appTheme}>
      <RouteNavigation />
      </ThemeProvider>
  )
}

export default App;
